import React from "react";

const ChequePage = () => {
  const handlePrint = () => {
    const chequeContent = `
      <html>
        <head>
          <title>Print Cheque</title>
          <style>
            @page {
              size: 7.5in 3.5in;
              margin: 0;
            }

            html, body {
              width: 7.5in;
              height: 3.5in;
              margin: 0;
              padding: 0;
              background: white;
              -webkit-print-color-adjust: exact !important;
            }

            .cheque {
              width: 7.5in;
              height: 3.5in;
              border: 1px solid #ccc;
              box-sizing: border-box;
              padding: 0.3in;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              font-family: Arial, sans-serif;
              font-size: 14px;
            }

            .header, .footer {
              display: flex;
              justify-content: space-between;
              font-size: 12px;
            }

            .payeeSection {
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size: 14px;
            }
          </style>
        </head>
        <body>
          <div class="cheque">
            <div class="header">
              <span>Bank Name</span>
              <span>Date: 01/11/2025</span>
            </div>

            <div class="payeeSection">
              <p>Pay: <strong>John Samuel</strong></p>
              <p>Amount: <strong>₦100,000.00</strong></p>
            </div>

            <div class="footer">
              <p>Authorized Signature</p>
            </div>
          </div>
        </body>
      </html>
    `;

    // Create a print window
    const printWindow = window.open("", "_blank", "width=800,height=500");
    printWindow.document.open();
    printWindow.document.write(chequeContent);
    printWindow.document.close();

    // Wait for the content to load before printing
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#e9ecef",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "7.5in",
          height: "3.5in",
          background: "white",
          border: "1px solid #ccc",
          padding: "0.3in",
          boxSizing: "border-box",
          fontFamily: "Arial, sans-serif",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          boxShadow: "0 0 5px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "12px",
          }}
        >
          <span>Bank Name</span>
          <span>Date: 01/11/2025</span>
        </div>

        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontSize: "14px",
          }}
        >
          <p>Pay: <strong>John Samuel</strong></p>
          <p>Amount: <strong>₦100,000.00</strong></p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "12px",
          }}
        >
          <p>Authorized Signature</p>
        </div>
      </div>

      <button
        onClick={handlePrint}
        style={{
          marginTop: "20px",
          background: "#0d6efd",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        Print Cheque
      </button>
    </div>
  );
};

export default ChequePage;
